import {useContext, useState} from "react";
import {API_APARTMENT_SEARCH_RESORTS_SEARCH, API_APARTMENT_SEARCH_APARTMENT_CATEGORIES} from "../common/api/apiConstants";
import {
    TRIAL_POINTS_TO_FIAT_CURRENCY
} from "../common/constant";
import {createURLQuery} from "../common/api/apiUtil";
import {apartmentSearchAPI} from "../common/api/apartmentSearchAPI";
import {CurrencyContext} from "../store/providers/CurrencyProvider";
import {useCurrencyConversion, useKeycloakFunctions} from ".";

export const useApartmentSearch = () => {
    const [apartmentsList, setApartmentsList] = useState();
    const [maxNumberOfGuests, setMaxNumberOfGuests] = useState(8);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currencyState] = useContext(CurrencyContext);
    const {getCurrencyConversion} = useCurrencyConversion();
    const {isTrialMember} = useKeycloakFunctions();

    /* Function to load the Apartments
     * If the userCurrency is specified, the function ignores the withCurrencyConversion flag and sends the request with
     * the specified userCurrency
     * If no useCurrency is specified, the function get the currency from the currencyState
     * (Side note) The currencyState currency might be different from the userState currency
     */
    const loadApartments = (params, withCurrencyConversion = false, userCurrency = undefined) => {
        setLoading(true);
        setError(null);

        if (params?.flexible_dates) {
            params.duration = params.flexible_dates;
            delete params.flexible_dates;
        }

        if(isTrialMember()) {
            params.trial = true;
        }

        return apartmentSearchAPI.get(API_APARTMENT_SEARCH_RESORTS_SEARCH + API_APARTMENT_SEARCH_APARTMENT_CATEGORIES + createURLQuery(params))
            .then(async res => {
                const data = res.data;
                if ((withCurrencyConversion || typeof userCurrency !== "undefined") && params.apartment_short_code) {
                    let toCurrency;
                    if (userCurrency && userCurrency !== data?.apartments[0].currency) {
                        toCurrency = userCurrency;
                    } else if (withCurrencyConversion && currencyState.currency !== data?.apartments[0].currency) {
                        // Apply currency conversion when requesting a single apartment only and
                        // flag is true and userCurrency is not specified
                        toCurrency = currencyState.currency;
                    }

                    if (toCurrency) {
                        let toBeConverted = [{
                            label: "local_costs",
                            from_currency: data?.apartments[0]?.currency,
                            to_currency: toCurrency,
                            convert_amount: data?.apartments[0]?.local_costs
                        }];

                        if (isTrialMember()) {
                            toBeConverted.push({
                                label: "trial_booking_costs",
                                from_currency: data?.apartments[0]?.currency,
                                to_currency: toCurrency,
                                convert_amount: data?.apartments[0]?.trial_booking_costs,
                                decimal_precision: toCurrency !== TRIAL_POINTS_TO_FIAT_CURRENCY ? 2 : 0
                            });
                        }

                        try {
                            const conversionResults = await getCurrencyConversion(toBeConverted);
                            data.apartments[0].converted_local_costs = conversionResults[0]?.result_amount;
                            if (isTrialMember()) {
                                data.apartments[0].converted_trial_booking_costs = conversionResults[1]?.result_amount;
                            }
                        } catch (err) {
                            // TODO expose a currencyConversion error to the component
                        }

                    }
                }
                setLoading(false);
                setApartmentsList(data?.apartments || []);
                setMaxNumberOfGuests(data.maximum_number_of_guests);
                return data;
            })
            .catch(err => {
                setLoading(false);
                setApartmentsList([]);
                setError(err);
                throw err.response;
            });
    };

    return {
        apartmentsList,
        maxNumberOfGuests,
        loadApartments,
        loading,
        error,
        setApartmentsList
    };
};
